document.addEventListener('DOMContentLoaded', () => {
  // Get the room (zaalverhuur) price from data attribute
  const roomPrice = parseFloat(document.querySelector('[data-roomprice]')?.getAttribute('data-roomprice')) || 0;
  const roomPriceNoVAT = parseFloat(document.querySelector('[data-roomprice_no_vat]')?.getAttribute('data-roomprice_no_vat')) || 0;

  // Select all inputs that have a data-price
  const dataPriceInputs = document.querySelectorAll('input[type="number"][data-price]');

  // Elements for displaying prices
  const roomPriceEl = document.getElementById('frm_desc_field_room_total');
  const optionsPriceEl = document.getElementById('frm_desc_field_options_total');
  const totalLabelEl = document.querySelector('#field_form_total_label h3');
  const totalLabelVatEl = document.querySelector('#field_form_total_label span');
  const hiddenTotalEl = document.getElementById('field_form_total');

  /**
   * Summation function: sum all data-price inputs + room price.
   */
  function updateTotal() {
    // Sum up all data-price inputs
    let optionsTotal = 0;
    let optionsTotalNoVAT = 0; // Nieuwe variable voor opties zonder BTW

    dataPriceInputs.forEach((input) => {
      const price = parseFloat(input.getAttribute('data-price')) || 0;
      const priceNoVAT = parseFloat(input.getAttribute('data-price_no_vat')) || 0; // Nieuwe data attribute
      const quantity = parseFloat(input.value) || 0;
      optionsTotal += price * quantity;
      optionsTotalNoVAT += priceNoVAT * quantity; // Bereken totaal zonder BTW
    });

    // Zaalverhuur + alle opties (met en zonder BTW)
    const overallTotal = roomPrice + optionsTotal;
    const overallTotalNoVAT = roomPriceNoVAT + optionsTotalNoVAT;

    // Update the "Zaalverhuur" display
    if (roomPriceEl) {
      roomPriceEl.textContent = `€${roomPrice.toFixed(2)}`;
    }

    // Update the "Opties" display
    if (optionsPriceEl) {
      optionsPriceEl.textContent = `€${optionsTotal.toFixed(2)}`;
    }

    // Update the main total
    if (totalLabelEl) {
      totalLabelEl.textContent = `TOTAAL €${overallTotal.toFixed(2)}`;

      // Controleer of totalLabelVatEl al bestaat
      if (!totalLabelVatEl) {
        const vatSpan = document.createElement('span');
        vatSpan.textContent = `(excl btw €${overallTotalNoVAT.toFixed(2)})`;
        vatSpan.style.display = 'block';
        totalLabelEl.appendChild(vatSpan);
      } else {
        totalLabelVatEl.textContent = `(excl btw €${overallTotalNoVAT.toFixed(2)})`;
        totalLabelVatEl.style.display = 'block';
      }
    }

    // Update the hidden form field, so it can be submitted
    if (hiddenTotalEl) {
      hiddenTotalEl.value = overallTotal.toFixed(2);
    }
  }

  // Listen for changes on each data-price input
  dataPriceInputs.forEach((input) => {
    input.addEventListener('input', updateTotal);
  });

  // Run the initial calculation once the page is loaded
  updateTotal();
});

document.addEventListener('DOMContentLoaded', () => {
  const dateCalendar = document.getElementById('field_form_date');
  const timeSelect = document.getElementById('field_form_time');

  if (dateCalendar && timeSelect) {
    jQuery(dateCalendar).on('change', function () {
      console.log('Change Detected:', this.value);
      updateTimeSlots(this.value);
    });

    jQuery(dateCalendar).datepicker({
      dateFormat: 'dd-mm-yy',
      onSelect: function (dateText) {
        jQuery(this).trigger('change');
      },
    });
  }

  function updateTimeSlots(selectedDate) {
    fetch(ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'return_available_timeslots',
        date: selectedDate,
        post_id: post_id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Response:', data);
        if (data.status === 'success' && Array.isArray(data.timeslots)) {
          timeSelect.innerHTML = '';

          const defaultOption = document.createElement('option');
          defaultOption.value = '';

          if (data.timeslots.length === 0) {
            defaultOption.textContent = 'No availability on this day';
          } else {
            defaultOption.textContent = 'Select a timeslot';

            // Populate the select element with new options
            data.timeslots.forEach((slot) => {
              const option = document.createElement('option');
              option.value = slot.value;
              option.textContent = slot.label;
              timeSelect.appendChild(option);
            });
          }

          timeSelect.appendChild(defaultOption);
        } else {
          console.error('Invalid response format', data);
        }
      })
      .catch((error) => {
        console.error('AJAX Error:', error);
      });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const locationIdEl = document.querySelector('[data-maxpersons]');
  const peopleInput = document.getElementById('field_form_people');

  if (locationIdEl && peopleInput) {
    const maxPersons = parseInt(locationIdEl.getAttribute('data-maxpersons'), 10);
    if (maxPersons > 0) {
      peopleInput.setAttribute('max', maxPersons);
    }
  }
});
